import React, { Fragment, useRef, useState } from "react"
import { Button, Label, Segment } from "semantic-ui-react";
import { TResult, useLoading } from "../../../sg-core";
import SignatureCanvasComponent from 'react-signature-canvas'
import "./_SignatureInput.less";

function dataURLtoBlob(dataurl: string) {
    //@ts-ignore
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};

type TSignatureId = string;

interface SignatureCanvasProps {
    value?: TSignatureId;
    onChange?: (value?: TSignatureId) => any;

    signatoryName?: string;
    renderSignature: (id: TSignatureId) => any;
    onSaveSignature?: (data: File) => Promise<TResult<TSignatureId>>;

    removeSignatureConfirmationText: string;
    signatureCannotBeEmptyText: string;
    addNewSignatureText: string;
    addSignatureText: string;
    clearText: string;
    acceptText: string;
}

export const SignatureCanvas: React.FC<SignatureCanvasProps> = ({
    value,
    onChange,
    signatoryName,
    renderSignature,
    onSaveSignature: uploadSignature,


    removeSignatureConfirmationText,
    signatureCannotBeEmptyText,
    addNewSignatureText,
    addSignatureText,
    clearText,
    acceptText,
}) => {
    const canvasRef = useRef<any>();

    const [isEditing, setEditing] = useState(true);
    const [isEmpty, setEmpty] = useState(false);
    const [signature, setSignature] = useState<typeof value>(value);
    const { loading, loadError, startLoading, loadSuccess, loadErrored } = useLoading();

    const clearCanvas = () => {
        if (canvasRef.current) {
            canvasRef.current.clear()
        };
    };

    const removeSignature = () => {
        var confirmRemove = window.confirm(removeSignatureConfirmationText);
        if (confirmRemove == true) { // eslint-disable-line eqeqeq
            setSignature(undefined);
            onChange && onChange(undefined);
            setEditing(true);
            setEmpty(false);
        }
    };

    const updateSignature = async () => {
        const signatureCanvas: any = canvasRef.current;
        if (signatureCanvas && uploadSignature) {
            if (signatureCanvas.isEmpty()) {
                setEmpty(true)
                return
            }

            const signature = signatureCanvas.getCanvas().toDataURL('image/png')
            const data = dataURLtoBlob(signature);
            startLoading();
            const result = await uploadSignature(data as File);
            if (result.isFailure) {
                loadErrored(result.error.message);
                return;
            };

            loadSuccess();
            setSignature(result.value);
            setEditing(false);
            isEmpty && setEmpty(false);
        };
    };


    const errorText = loadError ? loadError : isEmpty ? signatureCannotBeEmptyText : null;

    return (
        <Segment loading={loading} basic style={{ padding: 0 }} className="SignatureInput-wrapper">
            {signature ? (
                <Fragment>
                    <div className="Signature">
                        {renderSignature(signature)}
                    </div>
                    <Button.Group style={{ marginTop: '10px' }}>
                        <Button name={signatoryName} type="button" onClick={removeSignature}> {addNewSignatureText} </Button>
                    </Button.Group>
                </Fragment>
            ) : isEditing ? (
                <div className={"SignatureCanvas-input" + (isEditing ? " editing" : "")} >
                    <SignatureCanvasComponent
                        ref={canvasRef}
                        penColor='black'
                        canvasProps={{ className: ('sigCanvas' + (loadError || isEmpty ? ' error' : '')) }}
                    />

                    {errorText && <Label basic prompt pointing content={errorText} />}

                    {isEditing ?
                        (
                            <Button.Group style={{ width: '100%' }}>
                                <Button type="button" onClick={clearCanvas}> {clearText} </Button>
                                <Button name={signatoryName} type="button" onClick={updateSignature} primary> {acceptText} </Button>

                            </Button.Group>
                        ) : (
                            (
                                <Button.Group style={{ marginTop: '10px' }}>
                                    <Button name={signatoryName} onClick={() => setEditing(true)}> {addSignatureText} </Button>
                                </Button.Group>
                            )
                        )
                    }
                </div>
            ) : null}




        </Segment>
    );
};